export default {"src":"/_next/static/media/play_bold.8994503c.svg","height":24,"width":24};